import { DateTime } from 'luxon';
import { EmptyBasicPost, EmptyCommunityQuestion, EmptyEvent, EmptyMarketplaceItem, EmptyPoll, toString } from 'model';

export const getEmptyPost = (postType: string) => {
	switch (postType) {
		case 'marketplaceItem':
			return EmptyMarketplaceItem;
		case 'event':
			return {
				...EmptyEvent,
				eventDate: toString(DateTime.now().plus({ days: 1 }).set({ hour: 17, minute: 0, millisecond: 0 })),
				eventEndDate: ''
			};
		case 'poll':
			return EmptyPoll;
		case 'communityQuestion':
			return EmptyCommunityQuestion;
		default:
			return EmptyBasicPost;
	}
};
